import { Helmet } from "react-helmet-async";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthProvider";
import { useNavigate } from "react-router-dom";

const NotAuthorized = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <Helmet>
        <title>Not authorized · AI-labbet</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="max-w-md text-center">
        <h1 className="text-2xl font-semibold mb-2">Not authorized</h1>
        <p className="text-muted-foreground mb-6">
          Your account is signed in but does not have admin access.
        </p>
        <Button variant="decline" onClick={handleSignOut}>Sign out</Button>
      </div>
    </div>
  );
};

export default NotAuthorized;
